import { render, staticRenderFns } from "./BrickSettingsBase.vue?vue&type=template&id=0ee2c56f&scoped=true&"
import script from "./BrickSettingsBase.vue?vue&type=script&lang=js&"
export * from "./BrickSettingsBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee2c56f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ee2c56f')) {
      api.createRecord('0ee2c56f', component.options)
    } else {
      api.reload('0ee2c56f', component.options)
    }
    module.hot.accept("./BrickSettingsBase.vue?vue&type=template&id=0ee2c56f&scoped=true&", function () {
      api.rerender('0ee2c56f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/BrickSettings/BrickSettingsBase.vue"
export default component.exports